export default {"src":"/_next/static/media/shareFbGrey.5b3e9469.svg","height":32,"width":32};